import { useState } from 'react';

import { LegacyCloseButton } from 'components/LegacyButton/LegacyCloseButton';
import { useI18n } from 'i18n/hooks/useI18n';
import type { OrgDashboardApiOrg } from 'modules/orgDashboard/api/types/OrgDashboardApiOrg';
import { colors } from 'theme/theme';
import { getItem, setItem } from 'utils/localStorage';

import { getOrgPreviewInfoMessage } from './getOrgPreviewInfoMessage';

type Props = {
  org: OrgDashboardApiOrg;
};

export function OrgPreviewInfo({ org }: Props) {
  const { i18n } = useI18n();
  const previouslyDismissed = getItem('orgPreviewInfoDismissed') ?? {};
  const [dismissed, setDismissed] = useState(previouslyDismissed[org.id]);

  const closeInfo = () => {
    const dismissedList = localStorage.getItem('orgPreviewInfoDismissed') ?? {};
    setItem('orgPreviewInfoDismissed', { ...dismissedList, [org.id]: true });
    setDismissed(true);
  };

  if (dismissed) return null;

  return (
    <div
      style={{
        background: colors.softBlue,
        padding: 40,
        position: 'relative',
      }}
    >
      <div style={{ position: 'absolute', top: 12, right: 4 }}>
        <LegacyCloseButton onClick={closeInfo} />
      </div>

      <div
        style={{
          maxWidth: 1152,
          margin: '0 auto',
          fontSize: 16,
          lineHeight: 1.875,
        }}
      >
        {getOrgPreviewInfoMessage({ i18n, org })}
      </div>
    </div>
  );
}
